import { APP_INITIALIZER } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CharterColorService } from '../services/charter-color.service';
import { ConfigService } from '../services/config.service';

export function initCharterTheme(
  charterColor: CharterColorService,
  configService: ConfigService,
): () => Promise<void> {
  return async () => {
    await configService.loadAppConfig();
    await firstValueFrom(charterColor.load());
  };
}

export const themeInitializerProvider = {
  provide: APP_INITIALIZER,
  useFactory: initCharterTheme,
  multi: true,
  deps: [CharterColorService, ConfigService],
};
